<template>
  <div class="mt-2">
    現在の記事のステータス：
    <span class="font-weight-bold">{{ postI18ns.status[post.status] }}</span>
    <div class="mt-1">
      <span class="caption">最終更新：{{ post.updatedAt | moment }}</span>
    </div>
    <div v-if='post.releasedOn' class="mt-1">
      <span  class="caption">最終公開日：{{ post.releasedOn | moment }}</span>
    </div>
    <v-btn
      v-if="post.status == 'published'"
      class="mt-2"
      outlined
      color="indigo"
      :href="`${mediaRootPath()}${post.slug}`"
      target="_blank"
      small
    >
      公開記事を見る
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import urlUtils from '@/mixins/url_utils'

export default {
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  mixins: [urlUtils],
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      postI18ns: (state) => state.I18n.enums.post
    })
  }
}
</script>
